import React, { useState, useEffect, useRef } from "react";
import Icon from "./Icon";

function NewFolderModal({ onClose, onCreate }) {
  const [name, setName] = useState("");
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) onCreate(name.trim());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <Icon name="folderPlus" style={{ color: "#FF9900", fontSize: 20 }} />
          <h3>Create New Folder</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            ref={inputRef}
            className="modal-input"
            type="text"
            placeholder="Folder name..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Escape" && onClose()}
            maxLength={50}
          />
          <div className="modal-actions">
            <button type="button" className="modal-btn cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="modal-btn create" disabled={!name.trim()}>Create</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NewFolderModal;
